import { render } from "./MapProductDepotDrawer.vue?vue&type=template&id=2cf5fa05"
import script from "./MapProductDepotDrawer.vue?vue&type=script&lang=js"
export * from "./MapProductDepotDrawer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__